module.exports = __webpack_public_path__ + "fonts/VistaSansOT-Black.9ef54a23.otf";